import { SkeletonHeaderLayout } from './SkeletonHeaderLayout';
import { StyledGrid, StyledShellLayout } from './styled';
import type { SkeletonHeaderProps } from './types';
import type { FC } from 'react';

export const SkeletonHeader: FC<SkeletonHeaderProps> = ({ type }) => (
  <StyledShellLayout data-testid="Shell-layout-container-3">
    <StyledGrid data-testid="grid">
      <SkeletonHeaderLayout type={type} />
    </StyledGrid>
  </StyledShellLayout>
);
